<div class="xml-viewer" tabindex="0">
  <div class="xml-viewer__frame" *ngIf="!error && xmlTree.length > 0">
    <div class="xml-viewer__content">
      <div class="xml-viewer__tree">
        <ng-container *ngFor="let item of renderItems; trackBy: trackByItemId">
          <!-- Opening tag -->
          <div class="xml-line" *ngIf="item.visible && item.type === 'opening'" [attr.data-level]="item.level">
            <span class="xml-indent">{{ getIndentation(item.level) }}</span>
            
            <!-- Collapsible toggle button -->
            <button 
              *ngIf="item.node.isCollapsible" 
              class="xml-toggle"
              (click)="toggleNode(item.node)"
              type="button">
              <i [class]="item.node.isExpanded ? FontAwesomeIcon.ChevronDown : FontAwesomeIcon.ChevronRight"></i>
            </button>
            <span *ngIf="!item.node.isCollapsible" class="xml-toggle-spacer"></span>
            
            <!-- Opening tag -->
            <span class="xml-tag">&lt;{{ item.node.name }}&gt;</span>
            
            <!-- If has single text child, show it inline -->
            <ng-container *ngIf="item.node.children && item.node.children.length === 1 && item.node.children[0].type === 'text'">
              <span [class]="getValueClass(item.node.children[0].text)">{{ item.node.children[0].text }}</span>
              <span class="xml-tag">&lt;/{{ item.node.name }}&gt;</span>
            </ng-container>
            
            <!-- If empty element, show closing tag inline -->
            <ng-container *ngIf="item.node.isEmpty">
              <span class="xml-tag">&lt;/{{ item.node.name }}&gt;</span>
            </ng-container>
            
            <!-- If collapsed with children, show collapsed indicator -->
            <ng-container *ngIf="item.node.isCollapsible && !item.node.isExpanded && !item.node.isEmpty && item.node.children && item.node.children.length > 0">
              <span class="xml-collapsed">...</span>
              <span class="xml-tag">&lt;/{{ item.node.name }}&gt;</span>
            </ng-container>
          </div>
          
          <!-- Closing tag (on separate line) -->
          <div class="xml-line" *ngIf="item.visible && item.type === 'closing'" [attr.data-level]="item.level">
            <span class="xml-indent">{{ getIndentation(item.level) }}</span>
            <span class="xml-toggle-spacer"></span>
            <span class="xml-tag">&lt;/{{ item.node.name }}&gt;</span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  
  <div class="xml-viewer__error" *ngIf="error">
    <p>{{ error }}</p>
  </div>
  
  <div class="xml-viewer__footer" *ngIf="!error && xmlTree.length > 0">
    <cap-button 
      styleClass="secondary"
      [label]="'intergrip.student-fetch-service.detail.xml.copy-xml' | translate"
      [icon]="FontAwesomeIcon.Clipboard"
      (click)="copyToClipboard()">
    </cap-button>
    
    <cap-button 
      styleClass="secondary"
      [label]="'intergrip.student-fetch-service.detail.xml.expand-all' | translate"
      [icon]="FontAwesomeIcon.ChevronDown"
      (click)="expandAll()">
    </cap-button>
    
    <cap-button 
      styleClass="secondary"
      [label]="'intergrip.student-fetch-service.detail.xml.collapse-all' | translate"
      [icon]="FontAwesomeIcon.ChevronRight"
      (click)="collapseAll()">
    </cap-button>
  </div>
</div>

